export const Melding = ({ message, animationClass }) => {
    if (!message) return null;
  
    return (
      <div className={`melding ${animationClass}`}>
        {message}
      </div>
    );
  };